export default {
  /* eslint-disable no-dupe-keys */
  order_pre_settlement: {
    prop: {
      sharing_amount: '渠道费',
      transaction_fee_amount: '手续费'
    }
  }
}
